type SharePointSyncToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Compact control for card headers (no surrounding bar). */
  variant?: 'row' | 'compact';
  disabled?: boolean;
};

/** Pill switch used on all Admin Hub SharePoint panels. */
export function SharePointSyncToggle({
  checked,
  onChange,
  variant = 'row',
  disabled = false,
}: SharePointSyncToggleProps) {
  return (
    <div
      className={[
        'settings-sharepoint-switch-row',
        variant === 'compact' ? 'settings-sharepoint-switch-row--compact' : '',
        disabled ? 'is-disabled' : '',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <label className="settings-sharepoint-switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="settings-sharepoint-switch__track" aria-hidden />
        <span className="settings-sharepoint-switch__label">
          {variant === 'compact' ? (checked ? 'Sync on' : 'Sync off') : 'Enable SharePoint sync'}
        </span>
      </label>
    </div>
  );
}
